import { FiltersCheckBox } from "./FiltersCheckBox";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { translate } from "../../../utils/translator";

import creative from "../../../../src/icons/cannaibs_effects/creative.svg";
import energetic from "../../../../src/icons/cannaibs_effects/energetic.svg";
import euphoric from "../../../../src/icons/cannaibs_effects/euphoric.svg";
import excited from "../../../../src/icons/cannaibs_effects/excited.svg";
import focussed from "../../../../src/icons/cannaibs_effects/focussed.svg";
import happy from "../../../../src/icons/cannaibs_effects/happy.svg";
import hungry from "../../../../src/icons/cannaibs_effects/hungry.svg";
import relaxed from "../../../../src/icons/cannaibs_effects/relaxed.svg";
import silly from "../../../../src/icons/cannaibs_effects/silly.svg";
import sleepy from "../../../../src/icons/cannaibs_effects/sleepy.svg";
import sociable from "../../../../src/icons/cannaibs_effects/sociable.svg";

const effectsIcons = {
    creative,
    energetic,
    euphoric,
    excited,
    focussed,
    happy,
    hungry,
    relaxed,
    silly,
    sleepy,
    sociable
}


type Props = {
    filterOptions: { value: string, isSelected: boolean, name: string, keyWordTitle: string }[];
    handleChooseFilter: (item: { value: string, isSelected: boolean }, isMultiSelect?: boolean) => () => void;
    defaultOpen?: boolean;

}
export const CannabisEffectsFilter: React.FC<Props> = ({ filterOptions, handleChooseFilter, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const { language = "de" } = useParams();
    const effectsOrder = ['relaxed', 'focussed', 'euphoric', 'sociable', 'sleepy', 'hungry', 'energetic', 'creative', 'excited', 'happy', 'silly'];

    // Sort filterOptions based on effectsOrder
    const sortedOptions = [...filterOptions].sort((a, b) => {
        return effectsOrder.indexOf(a.value) - effectsOrder.indexOf(b.value);
    });


    const primaryEffects = sortedOptions.slice(0, 3); // always visible
    const secondaryEffects = sortedOptions.slice(3); // hidable


    return (
        <div
            id="choose-treatment-cannabis-effects-filter"
            className="pt-2 pb-4 md:pt-4"
        >
            {/* title + open/close toggle */}
            <div
                id="choose-treatment-cannabis-effects-filter-title"
                className="flex justify-between items-center"
            >
                <div className="text-md font-medium capitalize my-3">{filterOptions[0].keyWordTitle}</div>
                {secondaryEffects.length > 0 && (
                    <div
                        className="
                            text-[14px]
                            font-mediumcapitalize 
                            my-3
                            cursor-pointer
                            text-[#0A9281]
                            md:hover:text-[#269C6E]
                            underline
                            transition-colors 
                        "
                        onClick={() => setIsOpen(!isOpen)}
                        id="choose-treatment-cannabis-effects-filter-toggle-trigger"
                    >
                        {isOpen
                            ? (translate(language, 'choose_treatment', 'default/show-less') || 'Weniger zeigen')
                            : (translate(language, 'choose_treatment', 'default/show-more') || 'Mehr zeigen')}
                    </div>
                )}
            </div>


            {/* primary effects - first three */}
            {primaryEffects.length > 0 && (
                <div
                    id="choose-treatment-cannabis-effects-primary-effects"
                    className="
                        grid 
                        grid-cols-3 
                        gap-2 
                        md:gap-3 
                        justify-items-stretch
                    "
                >
                    {primaryEffects.map(item => (
                        <EffectSelectableBox
                            key={item.value}
                            item={item}
                            isSelected={item.isSelected}
                            handleChooseFilter={handleChooseFilter}
                        />
                    ))}
                </div>
            )}

            {/* secondary effects - can be hidden by user */}
            {secondaryEffects.length > 0 && (
                <div
                    id="choose-treatment-cannabis-effects-secondary-effects"
                    className="grid transition-all duration-500 ease-in-out mt-2 md:mt-3"
                    style={{
                        overflow: 'hidden',
                        gridTemplateRows: isOpen ? '1fr' : '0fr',
                    }}
                >
                    <div className="overflow-hidden">
                        <div
                            id="choose-treatment-cannabis-effects-grid"
                            className="
                                grid 
                                grid-cols-3 
                                gap-2 
                                md:gap-3 
                                justify-items-stretch"
                        >
                            {secondaryEffects.map(item => (
                                <EffectSelectableBox
                                    key={item.value}
                                    item={item}
                                    isSelected={item.isSelected}
                                    handleChooseFilter={handleChooseFilter}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}


type EffectSelectableBoxProps = {
    item: {
        value: string;
        name: string;
    };
    isSelected: boolean;
    handleChooseFilter: (item: any) => () => void;
};


const EffectSelectableBox: React.FC<EffectSelectableBoxProps> = ({
    item,
    isSelected,
    handleChooseFilter,
}) => {
    return (
        <div
            id={`filter_${item.value}`}
            className="cursor-pointer grid gap-1 md:gap-2 py-2"
            onClick={() => {
                handleChooseFilter(item)();
            }}
            style={{
                border: "1px solid #DBE1EB",
                borderRadius: "6px",
                justifyItems: "center",
            }}
        >
            <img
                id="cannabis-effects__icon"
                className="w-[50px] md:w-[60px]"
                src={effectsIcons[item.value as keyof typeof effectsIcons]}
                alt=""
            />

            <span
                id="cannabis-effects__title"
                className="text-[12px] md:text-[14px]"
            >
                {item.name}
            </span>

            <FiltersCheckBox isSelected={isSelected} />
        </div>
    );
};
